export default __webpack_public_path__ + "static/media/gb.a9bd2845.svg";